import { z } from 'zod'

export const ADMINBILLINGPROXYGET_CONTRACT_VERSION = '1.0.0' as const
export const adminBillingProxyGetResponseSchema = z.unknown()
export type AdminBillingProxyGetResponse = z.infer<typeof adminBillingProxyGetResponseSchema>
